var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrencyDollar = function SvgCurrencyDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.203 21.375v-2.242q-1.4-.249-2.41-1.093-1.01-.843-1.493-2.36l1.488-.618q.433 1.245 1.233 1.904.8.66 2.138.659 1.16 0 2.047-.552t.887-1.752q0-1.04-.667-1.661-.666-.622-2.758-1.297-2.19-.693-3.042-1.62t-.852-2.332q0-1.617 1.136-2.546 1.134-.929 2.293-1.031V2.625h1.607v2.209q1.226.162 2.06.797.836.635 1.298 1.65l-1.466.672q-.353-.774-.984-1.203-.63-.429-1.658-.429-1.209 0-1.944.59t-.735 1.5q0 .935.752 1.496.753.56 2.796 1.174 1.9.578 2.836 1.644.935 1.068.935 2.564 0 1.757-1.13 2.727-1.131.971-2.76 1.15v2.209z"
  })));
};
export default SvgCurrencyDollar;